import { UseHotelFiltersFormProperties } from "@website/accommodation-ui/hotel-filter/hotel-filter.types";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { Filters } from "@website/widget/filter";
import { FC, memo } from "react";

const Component: FC<UseHotelFiltersFormProperties> = (properties) => {
  const {
    filtersSchema,
    mapFilterProps,
    trackingCallback,
    hotelListResultsCount,
    loading
  } = properties;
  return (
    <Filters
      mapFilterProps={mapFilterProps}
      trackingCallback={trackingCallback}
      resetButtonProps={{
        size: "small",
        color: "secondary",
        variant: "text"
      }}
      schema={filtersSchema}
      title="فیلترها"
      loading={hotelListResultsCount === "loading" || loading}
      filtersActionTitle={`مشاهده ${numberConvert(hotelListResultsCount ?? 0, {
        locale: "fa"
      })} نتیجه`}
      filtersClassName="xl:!max-h-[calc(100vh-96px)]"
    />
  );
};

export const HotelFilter = memo(Component, deepCompare);
